import type { LocaleParams } from '@lotta/self-service/lottery-fe/types-router';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Hook which returns locale, retailUnit and language
 *
 * Example: { locale: 'en-CA', retailUnit: 'CA', language: 'en' }
 */
export const useLocale = () => {
  const { countryCode, language } = useParams<LocaleParams>() as LocaleParams;

  const locale = useMemo(
    () => ({
      language: language.toLowerCase(),
      locale: `${language.toLowerCase()}-${countryCode.toUpperCase()}`,
      retailUnit: countryCode.toUpperCase(),
    }),
    [countryCode, language]
  );

  return locale;
};
